import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllEmploymentTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmploymentType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getEmploymentTypeById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.EmploymentType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertEmploymentType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.EmploymentType, input);
  return data;
};

const updateEmploymentType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.EmploymentType, input);
  return data;
};

const deleteEmploymentType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.EmploymentType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetEmploymentTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmploymentType],
    queryFn: () => getAllEmploymentTypes(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetEmploymentTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.EmploymentType],
    queryFn: () => getEmploymentTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertEmploymentTypeMutation = () => {
  return useMutation({
    mutationFn: insertEmploymentType,
  });
};

export const useUpdateEmploymentTypeMutation = () => {
  return useMutation({
    mutationFn: updateEmploymentType,
  });
};

export const useDeleteEmploymentTypeMutation = () => {
  return useMutation({
    mutationFn: deleteEmploymentType,
  });
};
